<template>
  <v-dialog :value="dialog" @input="$emit('update:dialog', $event)" max-width="480">
    <v-card class="rounded-xl">
      <v-card-title class="subtitle-1 font-weight-bold">
        <v-icon left color="primary">mdi-file-tree-outline</v-icon>
        Mover {{ ids.length }} armario{{ ids.length > 1 ? "s" : "" }}
      </v-card-title>
      <v-card-text>
        <p class="text-body-2 mb-3">
          ¿Dentro de qué armario los quieres colocar? Se mueven con todo lo que cuelga de ellos.
        </p>
        <v-autocomplete
          v-model="destino"
          :items="opciones"
          item-text="nombre"
          item-value="id"
          label="Nuevo padre"
          prepend-inner-icon="mdi-magnify"
          outlined
          dense
          hide-details
          no-data-text="No hay ningún armario con ese nombre"
        >
          <template #item="{ item }">
            <span :style="{ paddingLeft: `${item.nivel * 14}px` }" class="d-flex align-center">
              <v-icon small class="mr-2" :color="item.id === RAIZ ? 'primary' : 'grey'">
                {{ item.id === RAIZ ? "mdi-home-outline" : "mdi-subdirectory-arrow-right" }}
              </v-icon>
              {{ item.nombre }}
            </span>
          </template>
        </v-autocomplete>
        <p class="text-caption grey--text mt-2 mb-0">
          No aparecen los armarios marcados ni los que cuelgan de ellos.
        </p>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="$emit('update:dialog', false)">Cancelar</v-btn>
        <v-btn color="primary" depressed :disabled="destino === null" :loading="guardando" @click="$emit('mover', { ids, id_parent: destino === RAIZ ? null : destino })">
          Mover
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// id ficticio para "sin padre" (v-autocomplete no distingue null de "nada elegido")
const RAIZ = "raiz";

export default {
  name: "DialogMoverArmarios",
  props: {
    dialog: { type: Boolean, default: false },
    ids: { type: Array, default: () => [] },
    arbol: { type: Array, default: () => [] },
    guardando: { type: Boolean, default: false },
  },
  data() {
    return { destino: null, RAIZ };
  },
  computed: {
    // todos los armarios en orden de árbol, salvo los marcados y sus descendientes
    opciones() {
      const lista = [{ id: RAIZ, nombre: "Ninguno (armario principal)", nivel: 0 }];
      const recorrer = (nodos, nivel) => {
        for (const n of nodos || []) {
          if (this.ids.includes(n.id)) continue;
          lista.push({ id: n.id, nombre: n.name, nivel });
          recorrer(n.children, nivel + 1);
        }
      };
      recorrer(this.arbol, 0);
      return lista;
    },
  },
  watch: {
    dialog(abierto) {
      if (abierto) this.destino = null;
    },
  },
};
</script>
